import { lazy } from "react";


export default [
    {
        path:"/dashboard",
        component:lazy(()=>import("../../views/dashboard/Dashboard")),
    },
    {
        path:"/dashboard-share/:type/:date",
        component:lazy(()=>import("../../views/dashboard/DashboardShare")),
    }
]